import React, { useState } from "react";
import { Search } from "lucide-react";
import { Button } from "./ui/Button";
import { useHistory } from "react-router-dom";

export const SearchBar = () => {
    const [query, setQuery] = useState("");
    const history = useHistory();

    const handleSearch = (e) => {
        e.preventDefault();
        if (query.trim()) {
            history.push(`/search?q=${encodeURIComponent(query.trim())}`);
        }
    };

    return (
        <form onSubmit={handleSearch} className="w-full max-w-2xl mx-auto">
            <div className="relative flex items-center">
                <div className="relative flex-1">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Search className="h-5 w-5 text-muted-foreground" />
                    </div>
                    <input
                        type="text"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        placeholder="Search tools..."
                        className="block w-full rounded-md border border-input bg-background px-3 py-2 pl-10 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    />
                </div>
                <Button type="submit" className="ml-2">
                    Search
                </Button>
            </div>
        </form>
    );
};
